module.exports = __webpack_public_path__ + "static/media/Youtube.d6806504.svg";